/**
 * Detects errors caused by request abort (e.g. full-page navigation, tab close).
 * Browser aborts in-flight XHR when user navigates away → Axios throws "Network Error"
 * with no response and status 0. We should not log these or report to Sentry.
 */
export function isRequestAborted(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const err = error as { code?: string; message?: string; response?: unknown };
  if (err.code === 'ERR_CANCELED') return true;
  if (err.message === 'Network Error' && err.response == null) return true;
  return false;
}
